import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  updateProfile,
  signOut,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
// export const analytics = getAnalytics(app);
export const analytics = null;
export const auth = getAuth(app);

// Keep Firebase authentication within the browser session.
export const configureAuthPersistence = async () => {
  await setPersistence(auth, browserSessionPersistence);
};

// Sign in with Google (renamed for clarity)
export const loginWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  provider.addScope("profile");
  provider.addScope("email");

  provider.setCustomParameters({
    prompt: "select_account consent",
  });

  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const providerData = user.providerData[0];

    if (user) {
      await updateProfile(user, {
        displayName: user.displayName || providerData.displayName,
        email: user.email || providerData.email,
      });
      console.log("✅ Successfully signed in with Google.");
    }

    return user;
  } catch (error) {
    console.error("signInWithPopup error:", error);
    throw error;
  }
};

// Sign in with Email and Password
export const signInWithEmail = async (email, password) => {
  try {
    // Configure browser session persistence before signing in.
    await configureAuthPersistence();

    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password,
    );
    return userCredential.user;
  } catch (error) {
    console.error("signInWithEmailAndPassword error:", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
  } catch (err) {
    console.error("Sign out error:", err);
    throw err;
  }
};

// Register a successful login in the backend.
export const registerLogin = async (user) => {
  const token = await user.getIdToken();

  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/v1/auth/session/login`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to register login session.");
  }

  return response.json();
};
